
import Vue, { ComponentPublicInstance, StyleValue } from "vue";
import Component from "vue-class-component";
import { BModal, VBModal } from "bootstrap-vue";
import { Prop, Watch } from "vue-property-decorator";
import { Action } from "vuex-class";
import { SalesToken } from "@/store/school/types";
import toast from "@/functions/toast.function";
import filters from "@/filters";
import moment from "moment";
import VueSelect, { VueSelectConstructor } from "vue-select";
import { baseCDC } from "@/functions/apibase.function";

@Component({
  components: {
    BModal,
  },
  directives: {
    "b-modal": VBModal,
  },
  filters,
})
export default class ModalRegistration extends Vue {
  @Action("getSchoolRequestDetail", { namespace: "school" })
  getSchoolRequestDetail: any;
  @Action("schoolRequestValidateToken", { namespace: "school" })
  schoolRequestValidateToken!: ServiceCall<
    Respon<SalesToken>,
    { sales_token: string }
  >;
  @Action("schoolRequestRegisterFree", { namespace: "school" })
  schoolRequestRegisterFree: any;
  @Action("schoolRequestSendOTP", { namespace: "school" })
  schoolRequestSendOTP!: ServiceCall<Respon<any>, { email: string }>;
  @Action("schoolRequestValidateOTP", { namespace: "school" })
  schoolRequestValidateOTP!: ServiceCall<
    Respon<any>,
    { email: string; otp: string }
  >;

  @Prop({ default: true })
  private showModal!: boolean;

  @Prop({ default: () => [] })
  private schoolTypes!: Array<any>;
  @Prop({ default: () => [] })
  private provinces!: Array<any>;
  @Prop({ default: () => [] })
  private cities!: Array<any>;

  @Action("getCity", { namespace: "admin" })
  getCity: any;

  private activeScreen: string = "";
  private imageCropper: boolean = false;

  private selectedSchoolType: any = null;
  private schoolName: string = "";

  private adminName: string = "";
  private adminEmail: string = "";
  private adminPassword: string = "";
  private adminConfirmPassword: string = "";
  private adminPhone: string = "";
  private adminPosition: string = "";

  private otp: string[] = ["", "", "", "", "", ""];

  private schoolLogo: File | null = null;
  private schoolLogoPreview: string | null = null;

  private province: any = null;
  private city: any = null;
  private address: string = "";
  private phone: string = "";
  private email: string = "";

  private isCodeValid: boolean = false;
  private inputedCode: string = "";
  private codeError: boolean | null = null;
  private codeErrorMessage: string = "";
  private isLoading: boolean = false;
  private timeCountown: string | null = null;
  private baseCDC = baseCDC;

  frame: number | null = null;
  async updatePosition(
    e: HTMLElement,
    c: InstanceType<VueSelectConstructor>,
    style: StyleValue
  ) {
    const el = c.$el as HTMLElement;
    if (this.frame) clearInterval(this.frame);

    this.frame = setInterval(() => {
      if (!el.classList.contains("vs--open") && this.frame) {
        return clearInterval(this.frame);
      }
      const rect = el.getBoundingClientRect();
      const container = document.querySelector<HTMLDivElement>(
        ".modal-dialog-custom"
      );

      style["position"] = "fixed";
      style["z-index"] = "99999";
      style["left"] = `${rect.left}px`;
      style["top"] = `${rect.top + rect.height}px`;

      if (container) {
        const containerStyle = getComputedStyle(container);
        style["max-height"] = `${
          parseInt(containerStyle.height) - (rect.top + rect.height)
        }px`;
        style["bottom"] = containerStyle.marginBottom;
      }
      Object.entries(style).forEach(([k, v]) => e.style.setProperty(k, v));
    });
  }

  handleOtpInput(event: Event, index: number) {
    const cleaned = this.otp[index].replace(/\D/g, "").slice(-1);
    if (cleaned !== this.otp[index]) {
      this.$set(this.otp, index, cleaned);
    }
    if (cleaned && index < this.otp.length - 1) {
      const next = document.getElementById(
        "otp" + (index + 2)
      ) as HTMLInputElement;
      if (next) next.focus();
    }
  }

  handleOtpKeydown(event: KeyboardEvent, index: number) {
    if (event.key === "Backspace" && !this.otp[index] && index > 0) {
      event.preventDefault();
      const prev = document.getElementById("otp" + index) as HTMLInputElement;
      if (prev) {
        prev.focus();
        prev.select();
      }
    }
  }

  handleOtpPaste(event: ClipboardEvent) {
    const text =
      (event.clipboardData || (window as any).clipboardData)?.getData("text") ||
      "";
    const digits = text.replace(/\D/g, "").slice(0, this.otp.length);
    for (let i = 0; i < this.otp.length; i++) {
      this.$set(this.otp, i, digits[i] || "");
    }
    const focusIndex = Math.min(digits.length, this.otp.length - 1);
    this.$nextTick(() => {
      const target = document.getElementById(
        "otp" + (focusIndex + 1)
      ) as HTMLInputElement;
      if (target) target.focus();
    });
  }

  @Watch("schoolLogo")
  handleSchoolLogoChange() {
    if (this.schoolLogo)
      this.schoolLogoPreview = URL.createObjectURL(this.schoolLogo);
    else this.schoolLogoPreview = null;
  }

  onProvinceChange() {
    this.city = null;
    if (this.province) {
      this.getCity({
        params: {
          province: this.province.id,
        },
        success: (response: any) => {
          this.cities = response.data.data;
        },
      });
    }
  }

  async onInputedCodeChange() {
    if (this.inputedCode.length < 6) return;

    this.isLoading = true;
    this.schoolRequestValidateToken({
      params: {
        sales_token: this.inputedCode,
      },
      success: () => {
        this.isCodeValid = true;
        this.codeError = true;
        this.codeErrorMessage = "";
      },
      fail: (error) => {
        this.codeError = false;
        if (error.response && error.response.status === 404) {
          this.codeErrorMessage = "Kode tidak ditemukan";
        } else {
          this.codeErrorMessage = "Terjadi kesalahan saat memvalidasi kode";
        }
      },
      finally: () => {
        this.isLoading = false;
      },
    });
  }

  handleNextCodeButtonClicked() {
    if (this.inputedCode.length < 6) {
      toast.warning("Kode pendaftaran harus terdiri dari 6 karakter");
      return;
    }

    if (!this.isCodeValid) return;

    this.activeScreen = "1";
    // this.getSchoolRequestDetail({
    //   params: {
    //     code: this.inputedCode,
    //   },
    //   success: (response: AxiosResponse) => {
    //     let data = response.data.data;
    //     this.name = data.name;
    //     this.email = data.email;
    //     this.phone = data.phone;
    //     this.address = data.address;
    //     this.schoolType = data.school_type;
    //     this.country = data.city.province.country;
    //     this.province = data.city.province;
    //     this.city = data.city;
    //     this.subdomain = data.subdomain;
    //     this.logo = data.logo;
    //     this.adminName = data.admin_name;
    //     this.adminEmail = data.admin_email;
    //     this.adminPhone = data.admin_phone;
    //     this.subscription = data.latest_package.package;
    //     this.price = data.latest_package.price;
    //   }
    // });
  }

  handleNextStep() {
    switch (this.activeScreen) {
      case "1":
        if (!this.schoolName) {
          toast.warning("Masukkan nama sekolah");
          return;
        }
        if (!this.selectedSchoolType) {
          toast.warning("Pilih jenis sekolah");
          return;
        }

        this.activeScreen = "2";
        break;
      case "2":
        if (!this.adminName) {
          toast.warning("Masukkan nama admin");
          return;
        }
        if (!this.adminEmail) {
          toast.warning("Masukkan email admin");
          return;
        }
        if (!this.isEmail(this.adminEmail)) {
          toast.warning("Email admin tidak valid");
          return;
        }
        if (!this.adminPhone) {
          toast.warning("Masukkan nomor telepon admin");
          return;
        }
        if (
          this.adminPhone.replace("+62", "0").length < 9 ||
          this.adminPhone.replace("+62", "0").length > 13
        ) {
          toast.warning("Nomor kontak terdiri dari 9 hingga 13 nomor");
          return;
        }

        if (!this.adminPosition) {
          toast.warning("Masukkan jabatan admin");
          return;
        }
        // if (!this.adminPassword) {
        //   toast.warning("Masukkan kata sandi admin");
        //   return;
        // }
        // if (this.adminPassword !== this.adminConfirmPassword) {
        //   toast.warning("Kata sandi dan konfirmasi kata sandi tidak cocok");
        //   return;
        // }
        this.schoolRequestSendOTP({
          params: { email: this.adminEmail },
          success: () => {
            this.$options.filters?.countdown({
              tergetDate: moment().add(2, "minutes"),
              update: (time: moment.Duration, status) => {
                const minutes = String(time.minutes()).padStart(2, "0");
                const seconds = String(time.seconds()).padStart(2, "0");
                if (status === "done") this.timeCountown = null;
                else this.timeCountown = `${minutes}:${seconds}`;
              },
            });
          },
        });
        this.activeScreen = "3";
        break;
      case "3":
        this.timeCountown = null;
        this.schoolRequestValidateOTP({
          params: {
            email: this.adminEmail,
            otp: this.otp.join(""),
          },
          success: () => {
            this.activeScreen = "4";
          },
        });
        break;
      case "4":
        if (!this.schoolLogo) {
          toast.warning("Masukkan logo sekolah");
          return;
        }

        this.activeScreen = "5";
        break;
      case "5":
        if (!this.province?.id) {
          toast.warning("Provinsi harus dipilih");
          return;
        }
        if (!this.city?.id) {
          toast.warning("Kota harus dipilih");
          return;
        }
        if (!this.address) {
          toast.warning("Masukkan alamat Sekolah/perguruan tinggi");
          return;
        }
        if (!this.email) {
          toast.warning("Masukkan alamat e-mail Sekolah/perguruan tinggi");
          return;
        }
        if (!this.isEmail(this.email)) {
          toast.warning(
            "Masukkan format e-mail yang sesuai untuk login ke akun Sekolah/perguruan tinggi"
          );
          return;
        }
        if (!this.phone) {
          toast.warning("Masukkan nomor telepon Sekolah/perguruan tinggi");
          return;
        }
        if (
          this.phone.replace("+62", "0").length < 9 ||
          this.phone.replace("+62", "0").length > 13
        ) {
          toast.warning("Nomor kontak terdiri dari 9 hingga 13 nomor");
          return;
        }

        this.submitRegistration();
        break;
    }
  }

  isEmail(value: string) {
    return /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(value);
  }

  submitRegistration() {
    const formData = new FormData();
    formData.append("school_type_id", this.selectedSchoolType.id);
    // formData.append("subdomain", this.subdomain);
    if (this.schoolLogo) formData.append("logo", this.schoolLogo);
    formData.append("address", this.address);
    formData.append("phone", this.phone);
    formData.append("admin_email", this.adminEmail);
    formData.append("name", this.schoolName);
    formData.append("city_id", this.city?.id);
    formData.append("admin_name", this.adminName);
    formData.append("admin_phone", this.adminPhone);
    formData.append("admin_position", this.adminPosition);
    formData.append("email", this.email);

    this.schoolRequestRegisterFree({
      params: formData,
      success: () => {
        this.$emit("submit-registration");
        this.showModal = false;
      },
      fail: (error) => {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          toast.error(error.response.data.message);
        } else {
          toast.error("Terjadi kesalahan saat mendaftar. Silakan coba lagi.");
        }
      },
    });
  }

  handleBackButtonClicked() {
    switch (this.activeScreen) {
      case "1":
        this.activeScreen = "";
        break;
      case "2":
        this.activeScreen = "1";
        break;
      case "3":
        this.activeScreen = "2";
        break;
      case "4":
        this.activeScreen = "3";
        break;
      case "5":
        this.activeScreen = "4";
        break;
    }
  }

  onRequestNewOTP = false;
  async onResendOTP() {
    this.onRequestNewOTP = true;
    try {
      await this.schoolRequestSendOTP({
        params: { email: this.adminEmail },
        success: () => {
          this.$options.filters?.countdown({
            tergetDate: moment().add(2, "minutes"),
            update: (time: moment.Duration, status) => {
              const minutes = String(time.minutes()).padStart(2, "0");
              const seconds = String(time.seconds()).padStart(2, "0");
              if (status === "done") this.timeCountown = null;
              else this.timeCountown = `${minutes}:${seconds}`;
            },
          });
        },
      });
    } catch (error) {
      console.error(error);
    }
    this.onRequestNewOTP = false;
  }
}
